import * as SentryReact from "@sentry/react";

export const initSentry = () => {
  const app = window.location.hostname.includes("embroiderytrace") || process.env.REACT_APP_VARIANT === "embroiderytrace"
    ? "embroiderytrace" : "svgtrace";
  SentryReact.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    release: process.env.REACT_APP_SENTRY_RELEASE,
    initialScope: { tags: { app } },
    integrations: [
      SentryReact.browserTracingIntegration(),
      SentryReact.replayIntegration({
        maskAllInputs: true,
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    environment:
      window.location.hostname === "localhost" ? "development" : "production",
  });
};
